// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import Tdg_OrganisationListPagingResultModel from '../../model/tdg-organisation-list-paging-result-model';
import Tdg_OrganisationListPagingResultDTO from '../dto/tdg-organisation-list-paging-result-dto';
import dtoSchema from '../schemas/tdg-organisation-list-paging-result-schema';
import Tdg_OrganisationListModel from '../../model/tdg-organisation-list-model';
import ResourceLinkModel from '../../model/resource-link-model';
import PaginationDataModel from '../../model/pagination-data-model';

export default abstract class Tdg_OrganisationListPagingResultModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<Tdg_OrganisationListPagingResultDTO>) {
    super();
    if (data) {
      this.items = data.items?.map((i) => Tdg_OrganisationListModel.toModel(i)) ?? [];
      this.links = data.links?.map((i) => ResourceLinkModel.toModel(i)) ?? [];
      this.paginationData = data.paginationData ? PaginationDataModel.toModel(data.paginationData) : undefined;
    }
  }
  /**
  */
  items?: Tdg_OrganisationListModel[];
  /**
  */
  links?: ResourceLinkModel[];
  /**
  */
  paginationData?: PaginationDataModel;

  static toModel(dto: DeepPartial<Tdg_OrganisationListPagingResultDTO>): Tdg_OrganisationListPagingResultModel;
  static toModel(dto: DeepPartial<Tdg_OrganisationListPagingResultDTO> | undefined | null): Tdg_OrganisationListPagingResultModel | undefined;
  static toModel(dto: DeepPartial<Tdg_OrganisationListPagingResultDTO> | undefined | null): Tdg_OrganisationListPagingResultModel | undefined {
    return dto ? new Tdg_OrganisationListPagingResultModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<Tdg_OrganisationListPagingResultModel> | Tdg_OrganisationListPagingResultModel): Tdg_OrganisationListPagingResultDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      items: unwrapped.items,
      links: unwrapped.links,
      paginationData: unwrapped.paginationData,
    } as Tdg_OrganisationListPagingResultDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for Tdg_OrganisationListPagingResultModel, can not map to Tdg_OrganisationListPagingResultDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
